import React from 'react';
import Modal from 'react-bootstrap/Modal';
import ProductTooltip from './ProductTooltip';
import ProductInput from './ProductInput';
import ProductLabel from './ProductLabel';
import ProductDropdown from './ProductDropdown';
import ProductCheckbox from './ProductCheckbox';
import ChangesTable from './ChangesTable';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import '../styles.css';

const ProductModal = React.memo(function ProductModal({
  selectedProduct,
  productModalShow,
  setProductModalShow,
  handleClickApprove,
  handleClickDecline,
  styles,
  modalApproveBtn,
  modalDeclineBtn,
  modalCloseBtn,
  modalLoading,
}) {
  return (
    <React.Fragment>
      <Modal
        show={productModalShow}
        onHide={() => setProductModalShow(false)}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
            Product Update Details for{' '}
            {selectedProduct?.approved_at === null &&
            selectedProduct?.declined_at === null
              ? 'Approval'
              : selectedProduct?.approved_at !== null &&
                selectedProduct?.declined_at === null
              ? 'Approved'
              : selectedProduct?.approved_at === null &&
                selectedProduct?.declined_at !== null
              ? 'Declined'
              : null}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-6">
              <br />
              <section style={styles.fieldset}>
                <legend style={styles.legend}>Product Information</legend>
                <br />
                <div className="form-group row" style={styles.formGroup}>
                  <ProductLabel text="Product Name" />
                  <div
                    className="col-sm-8 row pr-0"
                    style={{ marginTop: '6px' }}
                  >
                    <div className="col-sm-11 row">
                      <ProductInput
                        name="product_name"
                        value={selectedProduct?.product_name}
                        changesField={selectedProduct?.changes?.text}
                      />
                    </div>
                    <div className="col-sm-1">
                      <ProductTooltip />
                    </div>
                  </div>
                </div>

                <div className="form-group row" style={styles.formGroup}>
                  <ProductLabel text="Generic Name" />
                  <div className="col-sm-8 row pr-0">
                    <div className="col-sm-11 row">
                      <ProductInput
                        name="generic_name"
                        value={selectedProduct?.generic_name}
                        changesField={selectedProduct?.changes?.text}
                      />
                    </div>
                    <div className="col-sm-1">
                      <ProductTooltip />
                    </div>
                  </div>
                </div>

                <div className="form-group row" style={styles.formGroup}>
                  <ProductLabel text="Product Segment" />
                  <div className="col-sm-8 row pr-0">
                    <div className="col-sm-11 row">
                      <select
                        className="form-control form-control-sm text-dark"
                        name="product_segment_id"
                        style={{ marginTop: '6px' }}
                        readOnly
                      >
                        <option disabled selected>
                          {selectedProduct?.product_segment}
                        </option>
                      </select>
                      <select
                        className="form-control form-control-sm text-dark"
                        name="product_sub_segment_id"
                        style={{ marginTop: '6px' }}
                        readOnly
                      >
                        <option disabled selected>
                          {selectedProduct?.product_sub_segment}
                        </option>
                      </select>
                    </div>
                    <div className="col-sm-1">
                      <ProductTooltip />
                    </div>
                  </div>
                </div>

                <div className="form-group row" style={styles.formGroup}>
                  <ProductLabel text="Product Group" />
                  <div
                    className="col-sm-8 row pr-0"
                    style={{ marginTop: '6px' }}
                  >
                    <div className="col-sm-11 row">
                      <select
                        className="form-control form-control-sm text-dark"
                        name="product_group_id"
                        style={{ marginTop: '3px' }}
                        readOnly
                      >
                        <option disabled selected>
                          {selectedProduct?.product_group}
                        </option>
                      </select>
                      <select
                        className="form-control form-control-sm text-dark"
                        name="product_sub_group_id"
                        style={{ marginTop: '6px' }}
                        readOnly
                      >
                        <option disabled selected>
                          {selectedProduct?.product_sub_group}
                        </option>
                      </select>
                    </div>
                    <div className="col-sm-1">
                      <ProductTooltip />
                    </div>
                  </div>
                </div>

                <div className="form-group row" style={styles.formGroup}>
                  <ProductLabel text="Supplier" />
                  <div className="col-sm-8 row pr-0">
                    <div className="col-sm-11 row">
                      <ProductDropdown
                        name="supplier_id"
                        value={selectedProduct?.supplier_name}
                        changesField={selectedProduct?.changes?.supplier}
                      />
                    </div>
                    <div className="col-sm-1">
                      <ProductTooltip />
                    </div>
                  </div>
                </div>

                <div className="form-group row" style={styles.formGroup}>
                  <ProductLabel text="Manufacturer" />
                  <div className="col-sm-8 row pr-0">
                    <div className="col-sm-11 row">
                      <ProductInput
                        name="manufacturer"
                        value={selectedProduct?.manufacturer}
                        changesField={selectedProduct?.changes?.text}
                      />
                    </div>
                    <div className="col-sm-1">
                      <ProductTooltip />
                    </div>
                  </div>
                </div>

                <div className="form-group row" style={styles.formGroup}>
                  <ProductLabel text="CPR Number" />
                  <div
                    className="col-sm-8 row pr-0"
                    style={{ marginTop: '6px' }}
                  >
                    <div className="col-sm-11 row">
                      <ProductInput
                        name="cpr_no"
                        value={selectedProduct?.cpr_no}
                        changesField={selectedProduct?.changes?.text}
                      />
                    </div>
                    <div className="col-sm-1">
                      <ProductTooltip />
                    </div>
                  </div>
                </div>

                <div className="form-group row" style={styles.formGroup}>
                  <ProductLabel text="CPR Expiry" />
                  <div className="col-sm-8 row pr-0">
                    <div className="col-sm-11 row">
                      <ProductInput
                        name="cpr_expiry"
                        value={selectedProduct?.cpr_expiry}
                        changesField={selectedProduct?.changes?.text}
                      />
                    </div>
                    <div className="col-sm-1">
                      <ProductTooltip />
                    </div>
                  </div>
                </div>

                <div className="form-group row" style={styles.formGroup}>
                  <ProductLabel text="CPR Document" />
                  <div className="col-sm-8 row pr-0">
                    <div className="col-sm-11 row">
                      <input
                        type="file"
                        className="form-control form-control-sm text-dark"
                        name="cpr_document"
                        id="cpr_document"
                        style={{ marginTop: '6px' }}
                        disabled={true}
                      />
                      <br />
                      {selectedProduct?.cpr_file_name !== '' ? (
                        <label className="font-weight-bold fs-6">
                          File:
                          <a
                            className="link-color ml-1"
                            href="#"
                            target="_blank"
                            rel="noreferrer"
                          >
                            {selectedProduct?.cpr_file_name}
                          </a>
                        </label>
                      ) : (
                        ''
                      )}
                    </div>
                    <div className="col-sm-1">
                      <ProductTooltip />
                    </div>
                  </div>
                </div>
              </section>

              <section style={styles.fieldset}>
                <legend style={styles.legend}>Product Payment Terms</legend>
                <br />
                <div className="form-group row" style={styles.formGroup}>
                  <div
                    className="col-sm-6 row pr-0"
                    style={{ marginTop: '6px' }}
                  >
                    <div className="col-sm-12 row">
                      <ProductInput
                        name="percent_down_payment"
                        value={selectedProduct?.percent_down_payment}
                        changesField={selectedProduct?.changes?.text}
                      />
                    </div>
                  </div>

                  <ProductLabel text="% Down Payment" />
                </div>

                <div className="form-group row" style={styles.formGroup}>
                  <div
                    className="col-sm-6 row pr-0"
                    style={{ marginTop: '6px' }}
                  >
                    <div className="col-sm-12 row">
                      <ProductInput
                        name="percent_intransit"
                        value={selectedProduct?.percent_intransit}
                        changesField={selectedProduct?.changes?.text}
                      />
                    </div>
                  </div>
                  <ProductLabel text="% In Transit" />
                </div>

                <div className="form-group row" style={styles.formGroup}>
                  <div
                    className="col-sm-6 row pr-0"
                    style={{ marginTop: '6px' }}
                  >
                    <div className="col-sm-12 row">
                      <ProductInput
                        name="percent_upon_delivery"
                        value={selectedProduct?.percent_upon_delivery}
                        changesField={selectedProduct?.changes?.text}
                      />
                    </div>
                  </div>
                  <ProductLabel text="% Upon Delivery" />
                </div>
                <br />
                <div className="col-md-12">
                  {selectedProduct?.payment_terms?.map((item, index) => (
                    <div className="row" key={index}>
                      <div className="col-md-4">
                        <ProductInput
                          name={`payments[${index}][percent_amount]`}
                          value={item?.percent_amount}
                        />
                      </div>

                      <div className="col-md-4">
                        <ProductInput
                          name={`payments[${index}][days_remaining]`}
                          value={item?.days_remaining}
                        />
                      </div>

                      <div className="col-md-3">
                        <label
                          className="col-sm-12 fs-6"
                          style={{ marginTop: '6px' }}
                        >
                          After Delivery
                        </label>
                      </div>
                    </div>
                  ))}
                </div>
                <br />
              </section>
            </div>
            <div className="col-md-6" style={styles.divPadding}>
              <section style={styles.fieldset}>
                <legend style={styles.legend}>Inventory</legend>
                <br />
                <div className="form-group row" style={styles.formGroup}>
                  <ProductLabel text="Stock Level" />
                  <div className="col-sm-8 row pr-0">
                    <div className="col-sm-11 row">
                      <ProductInput
                        name="stock_level"
                        value={selectedProduct?.stock_level}
                      />
                    </div>
                    <div className="col-sm-1">
                      <ProductTooltip />
                    </div>
                  </div>
                </div>

                <div className="form-group row" style={styles.formGroup}>
                  <ProductLabel text="Shelf Life" />
                  <div className="col-sm-8 row pr-0">
                    <div className="col-sm-8 row">
                      <ProductInput
                        name="shelf_life"
                        value={selectedProduct?.shelf_life}
                      />
                    </div>
                    <div className="col-sm-3">Months</div>
                    <div className="col-sm-1">
                      <ProductTooltip />
                    </div>
                  </div>
                </div>

                <div className="form-group row" style={styles.formGroup}>
                  <ProductLabel text="Minimum Order quantity" />
                  <div className="col-sm-8 row pr-0">
                    <div className="col-sm-11 row">
                      <ProductInput
                        name="quantity"
                        value={selectedProduct?.min_order_qty}
                      />
                    </div>
                    <div className="col-sm-1">
                      <ProductTooltip />
                    </div>
                  </div>
                </div>

                <div className="form-group row" style={styles.formGroup}>
                  <ProductLabel text="Safety Stock Level" />
                  <div className="col-sm-8 row pr-0">
                    <div className="col-sm-11 row">
                      <ProductInput
                        name="safety_stock_level"
                        value={selectedProduct?.safety_stock_level}
                      />
                    </div>
                    <div className="col-sm-1">
                      <ProductTooltip />
                    </div>
                  </div>
                </div>

                <div className="form-group row" style={styles.formGroup}>
                  <ProductLabel text="Forecast (Required)" />
                  <div className="col-sm-8 row pr-0">
                    <div className="col-sm-11 row">
                      <ProductInput
                        name="forecast"
                        value={selectedProduct?.forecast}
                      />
                    </div>
                    <div className="col-sm-1">
                      <ProductTooltip />
                    </div>
                  </div>
                </div>

                <div className="form-group row" style={styles.formGroup}>
                  <ProductLabel text="Supplier Lead Time" />
                  <div className="col-sm-8 row pr-0">
                    <div className="col-sm-8 row">
                      <ProductInput
                        name="supplier_lead_time"
                        value={selectedProduct?.supplier_lead_time}
                      />
                    </div>
                    <div className="col-sm-3">Days</div>
                    <div className="col-sm-1">
                      <ProductTooltip />
                    </div>
                  </div>
                </div>
              </section>

              <br />

              <section style={styles.fieldset}>
                <legend style={styles.legend}>Price & Cost</legend>
                <br />

                <div className="form-group row" style={styles.formGroup}>
                  <p class="text-danger">
                    Note: Fill out{' '}
                    <span className="font-weight-bold">
                      Cost Per Box and Selling Price Per Box
                    </span>{' '}
                    First and{' '}
                    <span className="font-weight-bold">Quantity Per Pack</span>{' '}
                    to compute Per Unit and VAT Ex.
                  </p>
                </div>
                <br />
                <div className="form-group row" style={styles.formGroup}>
                  <label
                    for="vat_exemption"
                    className="col-sm-4 col-form-label col-form-label-sm"
                  ></label>
                  <div className="col-sm-8" style={{ marginLeft: '-15px' }}>
                    <ProductCheckbox
                      name="vat_exemption"
                      value={selectedProduct?.vat_exemption}
                      label={`${' '}Vat Exemption`}
                      changesField={selectedProduct?.changes?.vat_exemption}
                    />
                  </div>
                </div>

                <div className="form-group row" style={styles.formGroup}>
                  <label
                    for="cost"
                    className="col-sm-4 col-form-label col-form-label-sm"
                  >
                    Cost Per Box <span className="float-right">&#8369;</span>
                  </label>
                  <div className="col-sm-8 row pr-0">
                    <div className="col-sm-11 row">
                      <ProductInput
                        name="cost"
                        value={selectedProduct?.cost.toFixed(2)}
                        changesField={selectedProduct?.changes?.text}
                      />
                    </div>
                    <div className="col-sm-1">
                      <ProductTooltip />
                    </div>
                  </div>
                </div>

                <div className="form-group row" style={styles.formGroup}>
                  <label
                    for="cost_vat"
                    className="col-sm-4 col-form-label col-form-label-sm"
                  >
                    Cost Per Box (Vat Ex){' '}
                    <span className="float-right">&#8369;</span>
                  </label>
                  <div className="col-sm-8 row pr-0">
                    <div className="col-sm-11 row">
                      <ProductInput
                        name="cost_vat"
                        value={selectedProduct?.cost_vat.toFixed(2)}
                        changesField={selectedProduct?.changes?.text}
                      />
                    </div>
                    <div className="col-sm-1">
                      <ProductTooltip />
                    </div>
                  </div>
                </div>

                <div className="form-group row" style={styles.formGroup}>
                  <label
                    for="cost_unit"
                    className="col-sm-4 col-form-label col-form-label-sm"
                  >
                    Cost Per Unit
                    <span className="float-right">&#8369;</span>
                  </label>
                  <div className="col-sm-8 row pr-0">
                    <div className="col-sm-11 row">
                      <ProductInput
                        name="cost_unit"
                        value={selectedProduct?.cost_unit.toFixed(2)}
                        changesField={selectedProduct?.changes?.text}
                      />
                    </div>
                    <div className="col-sm-1">
                      <ProductTooltip />
                    </div>
                  </div>
                </div>

                <div className="form-group row" style={styles.formGroup}>
                  <label
                    for="cost_vat_unit"
                    className="col-sm-4 col-form-label col-form-label-sm"
                  >
                    Cost Per Unit (Vat Ex){' '}
                    <span className="float-right">&#8369;</span>
                  </label>
                  <div className="col-sm-8 row pr-0">
                    <div className="col-sm-11 row">
                      <ProductInput
                        name="cost_vat_unit"
                        value={selectedProduct?.cost_unit_vat.toFixed(2)}
                        changesField={selectedProduct?.changes?.text}
                      />
                    </div>
                    <div className="col-sm-1">
                      <ProductTooltip />
                    </div>
                  </div>
                </div>

                <div className="form-group row" style={styles.formGroup}>
                  <label
                    for="selling_price"
                    className="col-sm-4 col-form-label col-form-label-sm"
                  >
                    Selling Price Per Box{' '}
                    <span className="float-right">&#8369;</span>
                  </label>
                  <div className="col-sm-8 row pr-0">
                    <div className="col-sm-11 row">
                      <ProductInput
                        name="selling_price"
                        value={selectedProduct?.selling_price.toFixed(2)}
                        changesField={selectedProduct?.changes?.text}
                      />
                    </div>
                    <div className="col-sm-1">
                      <ProductTooltip />
                    </div>
                  </div>
                </div>

                <div className="form-group row" style={styles.formGroup}>
                  <label
                    for="selling_price_vat"
                    className="col-sm-4 col-form-label col-form-label-sm"
                  >
                    Selling Price Per Box(Vat Ex){' '}
                    <span className="float-right">&#8369;</span>
                  </label>
                  <div className="col-sm-8 row pr-0">
                    <div className="col-sm-11 row">
                      <ProductInput
                        name="selling_price_vat"
                        value={selectedProduct?.selling_price_vat.toFixed(2)}
                        changesField={selectedProduct?.changes?.text}
                      />
                    </div>
                    <div className="col-sm-1">
                      <ProductTooltip />
                    </div>
                  </div>
                </div>

                <div className="form-group row" style={styles.formGroup}>
                  <label
                    for="selling_price_unit"
                    className="col-sm-4 col-form-label col-form-label-sm"
                  >
                    Selling Price Per Unit{' '}
                    <span className="float-right">&#8369;</span>
                  </label>
                  <div className="col-sm-8 row pr-0">
                    <div className="col-sm-11 row">
                      <ProductInput
                        name="selling_price_unit"
                        value={selectedProduct?.selling_price_unit.toFixed(2)}
                        changesField={selectedProduct?.changes?.text}
                      />
                    </div>
                    <div className="col-sm-1">
                      <ProductTooltip />
                    </div>
                  </div>
                </div>

                <div className="form-group row" style={styles.formGroup}>
                  <label
                    for="selling_price_unit_vat"
                    className="col-sm-4 col-form-label col-form-label-sm"
                  >
                    Selling Price Per Unit (Vat Ex){' '}
                    <span className="float-right">&#8369;</span>
                  </label>
                  <div className="col-sm-8 row pr-0">
                    <div className="col-sm-11 row">
                      <ProductInput
                        name="selling_price_unit_vat"
                        value={selectedProduct?.selling_price_unit_vat.toFixed(
                          2,
                        )}
                        changesField={selectedProduct?.changes?.text}
                      />
                    </div>
                    <div className="col-sm-1">
                      <ProductTooltip />
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
          <div class="row pt-5">
            <div class="col-md-8">
              <ChangesTable data={selectedProduct} />
            </div>
            <div className="col-md-4 d-flex gap-2 justify-content-center align-items-end">
              {selectedProduct?.approved_at === null &&
                selectedProduct?.declined_at === null && (
                  <React.Fragment>
                    <button
                      className="btn btn-success btn-sm changes-tbl-btn"
                      onClick={() => handleClickApprove(selectedProduct)}
                      disabled={modalApproveBtn}
                    >
                      Approved
                    </button>
                    <button
                      className="btn btn-danger btn-sm changes-tbl-btn"
                      onClick={() => handleClickDecline(selectedProduct)}
                      disabled={modalDeclineBtn}
                    >
                      Declined
                    </button>
                    <button
                      className="btn btn-outline-secondary btn-sm changes-tbl-btn"
                      onClick={() => setProductModalShow(false)}
                      disabled={modalCloseBtn}
                    >
                      Close
                    </button>
                  </React.Fragment>
                )}
            </div>
          </div>

          {modalLoading && (
            <Backdrop
              sx={(theme) => ({
                color: '#fff',
                zIndex: theme.zIndex.drawer + 1,
              })}
              open={modalLoading}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          )}
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
});

export default ProductModal;
